
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 13.99H1V3.5","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M11.668 10V3.343H5","stroke":"currentColor","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M5 10l6.5-6.5","stroke":"currentColor","stroke-width":"1.5"}})])
          )
        }
      }
    